import i18n from '../i18n';
import plansApi from '../api/plansApi';
import { actions as notificationActions } from './notificationActions';
import { actions as userActions } from './userActions';
import { actions as walletActions } from './walletActions';
import * as logger from '../utils/logger';

export const types = {
  GET_PLANS: 'GET_PLANS',
  GET_PLANS_SUCCESS: 'GET_PLANS_SUCCESS',
  GET_PLANS_FAILURE: 'GET_PLANS_FAILURE',
  GET_TENANT_BIKE_TYPES: 'GET_TENANT_BIKE_TYPES',
  GET_TENANT_BIKE_TYPES_SUCCESS: 'GET_TENANT_BIKE_TYPES_SUCCESS',
  GET_TENANT_BIKE_TYPES_FAILURE: 'GET_TENANT_BIKE_TYPES_FAILURE',
  BUY_PLAN: 'BUY_PLAN',
  BUY_PLAN_SUCCESS: 'BUY_PLAN_SUCCESS',
  BUY_PLAN_FAILURE: 'BUY_PLAN_FAILURE',
  REDEEM_VOUCHER: 'REDEEM_VOUCHER',
  REDEEM_VOUCHER_SUCCESS: 'REDEEM_VOUCHER_SUCCESS',
  REDEEM_VOUCHER_FAILURE: 'REDEEM_VOUCHER_FAILURE',
  CONFIRM_END_PLAN_INFO: 'CONFIRM_END_PLAN_INFO',
  CONFIRM_END_PLAN_INFO_SUCCESS: 'CONFIRM_END_PLAN_INFO_SUCCESS',
  CONFIRM_END_PLAN_INFO_FAILURE: 'CONFIRM_END_PLAN_INFO_FAILURE',

};

export const actions = {
  load: () => dispatch => {
    dispatch({ type: types.GET_PLANS });
    return plansApi
      .get()
      .then(response => {
        if (response.ok && response.data && response.data.success !== false) {
          dispatch({ type: types.GET_PLANS_SUCCESS, plans: response.data });
          return dispatch(actions.loadBikeTypesForTenants(response.data.map(plan => plan.tenant)));
        }
        if(response.ok && response.data && response.data.success === false ) {
          return dispatch({ type: types.GET_PLANS_SUCCESS, plans: [] });
        }

        dispatch({ type: types.GET_PLANS_FAILURE });
        dispatch(notificationActions.showError(i18n.t('plans.actions.loadPlansFailure')));
        return logger.error(response);
      });
  },

  loadBikeTypesForTenants: tenants => (dispatch, getState) => {
    const uniqueTenants = [...new Set((tenants || []).filter(tenant => !!tenant))];
    const plansState = getState().plans;
    const tenantsToLoad = uniqueTenants.filter(tenant =>
      !plansState.bikeTypesByTenant[tenant] && !plansState.bikeTypesFetchingByTenant[tenant]
    );

    return Promise.all(tenantsToLoad.map(tenant => {
      dispatch({ type: types.GET_TENANT_BIKE_TYPES, tenant });
      return plansApi
        .getTenantBikeTypes(tenant)
        .then(response => {
          if (response.ok && response.data && response.data.success !== false) {
            return dispatch({ type: types.GET_TENANT_BIKE_TYPES_SUCCESS, tenant, bikeTypes: response.data });
          }

          dispatch({ type: types.GET_TENANT_BIKE_TYPES_FAILURE, tenant });
          return logger.error(response);
        });
    }));
  },

  buy: planId => dispatch => {
    dispatch({ type: types.BUY_PLAN });
    return plansApi
      .buy(planId)
      .then(response => {
        if (response.ok && response.data && response.data.success !== false) {
          dispatch({ type: types.BUY_PLAN_SUCCESS });
          dispatch(userActions.loadUserState());
          dispatch(walletActions.loadWallet());
          return;
        }

        dispatch({ type: types.BUY_PLAN_FAILURE });
        const errorKey = response.data && response.data.failure && response.data.failure.errorCode;
        dispatch(notificationActions.showError(i18n.t(errorKey || 'plans.actions.buyFailure')));
        return logger.error(response);
      });
  },
  redeemVoucher: code => dispatch => {
    dispatch({ type: types.REDEEM_VOUCHER });
    return plansApi
      .redeemVoucher(code)
      .then(response => {
        if (response.ok && response.data && response.data.success !== false) {
          dispatch({ type: types.REDEEM_VOUCHER_SUCCESS });
          dispatch(notificationActions.showSuccess(i18n.t('plans.voucherRedeem.success', { planName: response.data.planName })));
          dispatch(userActions.loadUserState());
          dispatch(actions.load());
          return true;
        }

        dispatch({ type: types.REDEEM_VOUCHER_FAILURE });
        const errorKey = response.data && response.data.failure && response.data.failure.errorCode;
        dispatch(notificationActions.showError(i18n.t(errorKey || 'plans.voucherRedeem.failure')));
        logger.error(response);
        return false;
      });
  },
  confirmEndPlanInfo: (id) => dispatch => {
    dispatch({type: types.CONFIRM_END_PLAN_INFO});
    return plansApi.confirmPlanEndInfo(id).then(() => {
      //dispatch(notificationActions.showSuccess(i18n.t('wallet.actions.confirmAutomaticWithdrawalInfoSuccess')));
      return dispatch({type: types.CONFIRM_END_PLAN_INFO_SUCCESS, id});
    })
      .catch(() => {
        return dispatch({type: types.CONFIRM_END_PLAN_INFO_FAILURE, id});
      });
  }};
